import {MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY, MatTooltipDefaultOptions} from '@angular/material/tooltip';


/**
 * Custom options configuring the tooltip's default show/hide delays.
 * Disables the tooltip's interactivity (hover, focus, keyboard) by default.
 */
export const matTooltipDisabledInteractivity: MatTooltipDefaultOptions = {
  ...MAT_TOOLTIP_DEFAULT_OPTIONS_FACTORY(),
  disableTooltipInteractivity: true,
};
